import { Injectable } from '@angular/core';
import { BrsSettingsInterface } from '@zaoblako/shared/modules/saas/dtos/brs-settings.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';
import type { AgentFindInterface } from '@zaoblako/shared/modules/ai/dtos/agent/agent-find.dto';

@Injectable({
  providedIn: 'root'
})
export class PaymentsSettingsService extends BaseService {
  protected baseUrl = '/finance/brs/settings';

  public getBrsSettings(): Observable<BrsSettingsInterface> {
    return this.http.get<BrsSettingsInterface>(this.baseUrl);
  }

  public setBrsSettings(params: BrsSettingsInterface): Observable<BrsSettingsInterface> {
    return this.http.put<BrsSettingsInterface>(this.baseUrl, params);
  }

  public getDefaultAgent(): Observable<AgentFindInterface> {
    return this.http.get<AgentFindInterface>(`${this.baseUrl}/agent`);
  }

  public setDefaultAgent(agentId: number): Observable<AgentFindInterface> {
    return this.http.put<AgentFindInterface>(`${this.baseUrl}/agent/${agentId}`, null);
  }
}
